import {Button, Card} from 'antd';
import React from 'react';
import {FormattedNumber} from 'react-intl';
import { InputNumber } from 'antd';
import {useModal} from '../../components/hooks/useModal';
import {PriceLine, PriceLineTotal} from '../../components/price-line/PriceLine';

import {useOrder} from '../hooks/useOrder';
import {PaymentStatus} from './PaymentStatus';
import {UploadInvoiceModal} from './UploadInvoiceModal';

import { Order } from '../../hooks/data/models';

interface OrderPriceCardProps {
  order: Order | undefined;
  isEditMode: boolean;
  loading?: boolean;
  onDataEdited?: (updates: Partial<Order>) => void;
}

export const OrderPriceCard: React.FC<OrderPriceCardProps> = ({
  order, 
  isEditMode, 
  loading = false,
  onDataEdited
}) => {
  const {visible, openModal, closeModal} = useModal();
  const { downloadInvoice } = useOrder();

  const handleShippingTotalEdit = (value: number | null) => {
    if (onDataEdited) {
      // Pass the field name and the new value to the parent
      onDataEdited({shippingTotal: value || 0});
    }
  };

  const handleDownload = () => {
    if(!order)
      return;

    try {
      return downloadInvoice(order._id);
    } catch (e) {
      // TODO Handle notification + sentry
    }
  };

  const renderInvoiceButton = () => {
    if(!order)
      return;

    if(order.hasInvoice) {
      return <Button onClick={handleDownload} key="download-invoice-button">Download invoice</Button>;
    } else {
      return <Button onClick={openModal} key="upload-invoice-button">Upload invoice</Button>;
    }
  };

  return (
    <Card
      title={order && <PaymentStatus status={order.paymentStatus}/>}
      style={{marginTop: '1.6rem'}}
      extra={[
        renderInvoiceButton(),
      ]}
      loading={loading}
    >
      <PriceLine>
        <div>Subtotal</div>
        {order && !isEditMode && (
          <FormattedNumber value={order.itemTotal} currency={order.currency} style={'currency'}/>
        )}
        {order && isEditMode && (
          <p>Will be computed once saved </p>
        )}
      </PriceLine>

      <PriceLine>
        <div>Shipping</div>
        {order && !isEditMode && (
          <FormattedNumber value={order.shippingTotal} currency={order?.currency} style={'currency'}/>
        )}
        {order && isEditMode && (
          <InputNumber
            value={order.shippingTotal}
            onChange={handleShippingTotalEdit}  
            min={0}
            precision={2}
            addonAfter={order?.currency} 
            style={{ width: '150px' }}
            />
        )}
      </PriceLine>

      <PriceLineTotal>
        <div>Total</div>
        {order && !isEditMode && <FormattedNumber value={order.amountTotal} currency={order?.currency} style={'currency'}/>}
        {order && isEditMode && (
          <p>Will be computed once saved</p>
        )} 
      </PriceLineTotal>

      {visible && order && (
        <UploadInvoiceModal
          orderId={order._id}
          onClose={closeModal}
          onSuccess={closeModal}
        />
      )}
    </Card>
  );
};
